import React, {useEffect} from 'react'
import { signOutOfFirebase} from '../firebase/firebase'
import AtAGlance from './AtAGlance';
import styles from './home-style.module.css'

function Home({ setShowNavBar }) {

    useEffect(() => setShowNavBar(true));

    const handleSignOut = () => {
        signOutOfFirebase();
    } 

    const test = () => {
        
    }

    return (
        <div id={styles.home}>
            <h1>Home Page</h1>
            <AtAGlance/>
        </div>
    )
}

export default Home